import { useT } from '~/i18n';
import type { JobForYou, SavedJob } from '../api/freeTierClient';
import { ApplyAction, JobRow } from './JobsForYouCard';

/**
 * «Guardadas» (2026-10-30): las vacantes que la persona marcó para después,
 * con o sin plan. Sale solo cuando hay alguna (o cuando guardar falló, para
 * decirlo). Postular desde acá abre la misma hoja que el buscador.
 */
interface Props {
  jobs: SavedJob[];
  hasGmail: boolean;
  /** Postuladas en esta sesión. */
  applied: ReadonlySet<string>;
  onApply: (job: JobForYou) => void;
  onToggleSave: (job: JobForYou) => void;
  error?: string | null;
}

export default function SavedJobsCard({ jobs, hasGmail, applied, onApply, onToggleSave, error }: Props) {
  const t = useT('workspace').dashboard.jobsForYou;
  if (!jobs.length && !error) return null;
  return (
    <div className="card rise">
      <div className="card-body space-y-3">
        <h2 className="card-title">{t.saved.title}</h2>
        {jobs.length > 0 && <p className="text-sm hush">{t.saved.lede}</p>}
        {error && (
          <p className="text-sm" role="alert" style={{ color: 'var(--coral-ink)' }}>
            {error}
          </p>
        )}
        {jobs.map((job) => {
          const today = applied.has(job._id);
          return (
            <JobRow
              key={job._id}
              job={job}
              save={{ saved: true, onToggle: () => onToggleSave(job) }}
              action={
                <ApplyAction
                  job={job}
                  isApplied={today || job.applied}
                  appliedLabel={today ? t.applied : t.search.alreadyApplied}
                  hasGmail={hasGmail}
                  onApply={onApply}
                />
              }
            />
          );
        })}
      </div>
    </div>
  );
}
